import { DataService } from './dataService'
export const airConsolidationService = {
	add_cons_airfreightrats: async (data) => {
		return DataService.post('/admin/add_cons_airfreightrats', data)
	},

	update_cons_airfreightrats: async (data) => {
		return DataService.post('/admin/update_cons_airfreightrats', data)
	},

	update_cons_airfreightrats_status: async (data) => {
		return DataService.post('/admin/update_cons_airfreightrats_status', data)
	},

	get_cons_airfreightrats: async (data) => {
		return DataService.get('/admin/get_cons_airfreightrats', data)
	},

	import_airfreightrats_cons_data: async (data) => {
		return DataService.post('/admin/import_airfreightrats_cons_data', data)
	},

	export_airfreightrats_cons_data: async (data) => {
		return DataService.get('/admin/export_airfreightrats_cons_data', data)
	},

}

export default airConsolidationService;